import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import {
  Box, Typography, Grid, Container, Chip, Paper,
  Accordion, AccordionSummary, AccordionDetails,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField, InputAdornment, Button, Breadcrumbs,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import GavelIcon from '@mui/icons-material/Gavel';
import SEO, { organizationSchema, breadcrumbSchema } from '../../seo/SEO';
export const SCHEME_I_DATA = [
  {
    category: 'Cement',
    description: 'Any variety of cement manufactured or sold in India',
    notification: 'Cement (Quality Control) Order, 2003 — S.O. No. 191(E), Dt. 17 Feb 2003',
    image: 'https://images.unsplash.com/photo-1680357680725-f350480aee35?w=400&q=80',
    products: [
      { srNo: 1, isNo: 'IS 12330', product: 'Sulphate Resisting Portland Cement' },
      { srNo: 2, isNo: 'IS 12600', product: 'Low Heat Portland Cement' },
      { srNo: 3, isNo: 'IS 1489 (Part 1)', product: 'Portland Pozzolana Cement — Fly-ash Based' },
      { srNo: 4, isNo: 'IS 1489 (Part 2)', product: 'Portland Pozzolana Cement — Calcined Clay Based' },
      { srNo: 5, isNo: 'IS 269', product: 'Ordinary Portland Cement' },
      { srNo: 6, isNo: 'IS 3466', product: 'Masonry Cement' },
      { srNo: 7, isNo: 'IS 455', product: 'Portland Slag Cement' },
      { srNo: 8, isNo: 'IS 6452', product: 'High Alumina Cement for Structural Use' },
      { srNo: 9, isNo: 'IS 6909', product: 'Super Sulphated Cement' },
      { srNo: 10, isNo: 'IS 8041', product: 'Rapid Hardening Portland Cement' },
      { srNo: 11, isNo: 'IS 8042', product: 'White Portland Cement' },
      { srNo: 12, isNo: 'IS 8043', product: 'Hydrophobic Portland Cement' },
      { srNo: 13, isNo: 'IS 8229', product: 'Oil Well Cement' },
      { srNo: 14, isNo: 'IS 16415:2015', product: 'Composite Cement — Specification' },
      { srNo: 15, isNo: 'IS 16993:2018', product: 'Microfine Ordinary Portland Cement — Specification' },
      { srNo: 16, isNo: 'IS 15895:2018', product: 'High Alumina Refractory Cement' },
    ],
  },
  {
    category: 'Household Electrical Goods',
    notification: 'Electrical Wires, Cables, Appliances and Protection Devices and Accessories (Quality Control) Order, 2003 — No. 189(E), dated 17 Feb 2003 (as amended)',
    image: 'https://images.unsplash.com/photo-1612203264166-e00118d63b94?w=400&q=80',
    products: [
      { srNo: 17, isNo: 'IS 12640 (Part 1)', product: 'Residual Current Operated Circuit Breakers — Part 1 (without integral overcurrent protection)' },
      { srNo: 18, isNo: 'IS 12640 (Part 2)', product: 'Residual Current Operated Circuit Breakers — Part 2 (with integral overcurrent protection)' },
      { srNo: 19, isNo: 'IS 13010', product: 'AC Watt-hour Meters, Class 0.5, 1 & 2' },
      { srNo: 20, isNo: 'IS 13779', product: 'AC Static Watt-hour Meters, Class 1 & 2' },
      { srNo: 21, isNo: 'IS 14697', product: 'AC Static Transformer Operated Watt-hour and VAR-hour Meters, Class 0.2S & 0.5S' },
      { srNo: 22, isNo: 'IS 15111 (Part 1 & 2)', product: 'Self Ballasted Lamps for General Lighting Services — Safety & Performance Requirements' },
      { srNo: 23, isNo: 'IS 302 (Part 2/Sec 3)', product: 'Safety of Household Electrical Appliances — Electric Iron' },
      { srNo: 24, isNo: 'IS 302 (Part 2/Sec 201)', product: 'Safety of Household Electrical Appliances — Electric Immersion Water Heaters' },
      { srNo: 25, isNo: 'IS 302 (Part 2/Sec 202)', product: 'Safety of Household Electrical Appliances — Electric Stoves' },
      { srNo: 26, isNo: 'IS 302 (Part 2/Sec 30)', product: 'Safety of Household Electrical Appliances — Room Heaters' },
      { srNo: 27, isNo: 'IS 3854', product: 'Switches for Domestic and Similar Purposes' },
      { srNo: 28, isNo: 'IS 418', product: 'Tungsten Filament General Service Electric Lamps (up to 100W)' },
      { srNo: 29, isNo: 'IS 694', product: 'PVC Insulated Cables for Working Voltages up to and Including 1100V' },
      { srNo: 30, isNo: 'IS 8828 (revised as IS/IEC 60898)', product: 'Electrical Accessories — Circuit Breakers for Overcurrent Protection for Household Installations' },
      { srNo: 31, isNo: 'IS 9968 (Part 1)', product: 'Elastomer Insulated Cables — Working Voltages up to and Including 1100V' },
    ],
  },
  {
    category: 'Batteries',
    notification: 'S.O. 516(E), dated 25 May 1987',
    products: [
      { srNo: 32, isNo: 'IS 8144', product: 'Multi-Purpose Dry Batteries' },
    ],
  },
  {
    category: 'Food & Related Products',
    notification: 'Food Safety & Standards (Prohibition & Restriction on Sales) Regulation, 2011',
    products: [
      { srNo: null, isNo: 'IS 15757', product: 'Follow-up Formula — Complementary Foods' },
      { srNo: null, isNo: 'IS 11536', product: 'Processed Cereal Based Complementary Foods' },
      { srNo: null, isNo: 'IS 1165', product: 'Milk Powder' },
      { srNo: null, isNo: 'IS 1166', product: 'Condensed Milk, Partly Skimmed and Skimmed Condensed Milk' },
      { srNo: null, isNo: 'IS 12176', product: 'Sweetened Ultra High Temperature Treated Condensed Milk' },
      { srNo: null, isNo: 'IS 13334 (Part 1)', product: 'Skimmed Milk Powder, Standard Grade' },
      { srNo: null, isNo: 'IS 13334 (Part 2)', product: 'Skimmed Milk Powder, Extra Grade' },
      { srNo: null, isNo: 'IS 13428', product: 'Packaged Natural Mineral Water' },
      { srNo: null, isNo: 'IS 14433', product: 'Infant Milk Substitutes' },
      { srNo: null, isNo: 'IS 17945:2022', product: 'Food for Special Medical Purpose Intended for Infants' },
      { srNo: null, isNo: 'IS 14542', product: 'Partly Skimmed Milk Powder' },
      { srNo: null, isNo: 'IS 14543', product: 'Packaged Drinking Water (Other than Packaged Natural Mineral Water)' },
      { srNo: null, isNo: 'IS 1656', product: 'Milk-Cereal Based Complementary Foods' },
    ],
  },
  {
    category: 'Feeding Bottles',
    notification: 'The Infant Milk Substitutes, Feeding Bottles and Infant Foods (Regulation of Production, Supply and Distribution) Act, 1992',
    products: [
      { srNo: 33, isNo: 'IS 14625', product: 'Plastic Feeding Bottles' },
      { srNo: 34, isNo: 'IS 5168', product: 'Glass Feeding Bottles' },
    ],
  },
  {
    category: 'Oil Pressure Stoves',
    notification: 'Oil Pressure Stoves (Quality Control) Order, 1997 — S.O. 451(E), dated 16 June 1997',
    products: [
      { srNo: 35, isNo: 'IS 10109', product: 'Oil Pressure Stove, Offset Burner Type' },
      { srNo: 36, isNo: 'IS 2787', product: 'Multi-Burner Oil Pressure Stoves' },
      { srNo: 37, isNo: 'IS 1342', product: 'Oil Pressure Stoves' },
    ],
  },
  {
    category: 'Automobile Accessories',
    notification: 'Pneumatic Tyres and Tubes for Automotive Vehicles (Quality Control) Order, 2009 — S.O. No. 2953(E), dated 19-11-2009 (as amended)',
    products: [
      { srNo: 38, isNo: 'IS 13098', product: 'Automotive Vehicles — Tubes for Pneumatic Tyres' },
      { srNo: 39, isNo: 'IS 15627', product: 'Pneumatic Tyres for Two and Three-Wheeled Motor Vehicles' },
      { srNo: 40, isNo: 'IS 15633', product: 'Pneumatic Tyres for Passenger Car Vehicles — Diagonal and Radial Ply' },
      { srNo: 41, isNo: 'IS 15636', product: 'Pneumatic Tyres for Commercial Vehicles — Diagonal and Radial Ply' },
    ],
  },
  {
    category: 'Cylinders, Valves & Regulators',
    notification: 'Gas Cylinder Rules, 2016 — G.S.R. No. 1081(E), Dt. 22-11-2016 (as amended)',
    products: [
      { srNo: 42, isNo: 'IS 14899', product: 'Liquefied Petroleum Gas Containers for Automotive Use' },
      { srNo: 43, isNo: 'IS 15100', product: 'Multifunction Valve Assembly for Permanently Fixed LPG Containers (Automotive Use)' },
      { srNo: 44, isNo: 'IS 3196 (Part 4)', product: 'Welded Low Carbon Steel Cylinders — Toxic and Corrosive Gases' },
      { srNo: 45, isNo: 'IS 3196 (Part 1)', product: 'Welded Low Carbon Steel Gas Cylinders — LPG' },
      { srNo: 46, isNo: 'IS 3196 (Part 2)', product: 'Welded Low Carbon Steel Gas Cylinders — Liquefiable Gases Other than LPG' },
      { srNo: 47, isNo: 'IS 3224', product: 'Valve Fittings for Compressed Gas Cylinders (Excluding LPG)' },
      { srNo: 48, isNo: 'IS 3745', product: 'Yoke Type Valve Connection for Small Medical Gas Cylinders' },
      { srNo: 49, isNo: 'IS 7142', product: 'Welded Low Carbon Steel Cylinders (Not Exceeding 5L Water Capacity)' },
      { srNo: 50, isNo: 'IS 7285 (Part 1)', product: 'Refillable Seamless Steel Gas Cylinders — Normalized Steel' },
      { srNo: 51, isNo: 'IS 7285 (Part 2)', product: 'Refillable Seamless Steel Gas Cylinders — Quenched and Tempered Steel' },
      { srNo: 52, isNo: 'IS 7302', product: 'Valve Fittings for Gas Cylinder Valves (Breathing Apparatus)' },
      { srNo: 53, isNo: 'IS 7312', product: 'Welded and Seamless Steel Dissolved Acetylene Gas Cylinders' },
      { srNo: 54, isNo: 'IS 8737', product: 'Valve Fittings for LPG Cylinders (More than 5L Water Capacity)' },
      { srNo: 55, isNo: 'IS 8776', product: 'Valve Fittings for LPG Cylinders (Up to and Including 5L Water Capacity)' },
      { srNo: 56, isNo: 'IS 9798', product: 'Low Pressure Regulators for LPG Mixtures' },
    ],
  },
  {
    category: 'Medical Equipment',
    notification: 'Clinical Thermometers (Quality Control) Order, 2001 — GSR No. 843(E), dated 9 Nov 2001; Diagnostic Medical X-Ray Equipment Order, Oct 1994',
    products: [
      { srNo: 57, isNo: 'IS 3055 (Part 1)', product: 'Clinical Thermometers — Solid Stem Type' },
      { srNo: 58, isNo: 'IS 3055 (Part 2)', product: 'Clinical Thermometers — Enclosed Scale Type' },
      { srNo: 59, isNo: 'IS 7620 (Part 1)', product: 'Diagnostic Medical X-Ray Equipment' },
    ],
  },
  {
    category: 'Steel and Iron Products',
    notification: 'Steel and Steel Products (Quality Control) Order, 2024 — S.O. 3716(E), dated 29 Aug 2024 (as amended — this order has an extensive amendment history; see the official BIS notification for the full chain)',
    partial: true,
    products: [
      { srNo: 60, isNo: 'IS 1785 (Part 1):1983', product: 'Plain Hard-Drawn Steel Wire for Pre-stressed Concrete — Cold Drawn Stress-Relieved Wire' },
      { srNo: 61, isNo: 'IS 1785 (Part 2):1983', product: 'Plain Hard-Drawn Steel Wire for Pre-stressed Concrete — As Drawn Wire' },
      { srNo: 62, isNo: 'IS 6003:2010', product: 'Indented Wire for Pre-stressed Concrete' },
      { srNo: 63, isNo: 'IS 6006:2014', product: 'Uncoated Stress Relieved Strand for Pre-stressed Concrete' },
      { srNo: 64, isNo: 'IS 13620:1993', product: 'Fusion Bonded Epoxy Coated Reinforcing Bars' },
      { srNo: 65, isNo: 'IS 14268:1995', product: 'Uncoated Stress Relieved Low Relaxation Seven-Ply Strand for Pre-stressed Concrete' },
      { srNo: 66, isNo: 'IS 277:2003', product: 'Galvanized Steel Sheets (Plain and Corrugated)' },
      { srNo: 67, isNo: 'IS 2002:2009', product: 'Steel Plates for Pressure Vessels (Intermediate and High Temperature Service, Including Boilers)' },
    ],
  },
];

const TOTAL_PRODUCTS = SCHEME_I_DATA.reduce((sum, c) => sum + c.products.length, 0);

export function BISSchemeIProducts() {
  const [query, setQuery] = useState('');
  const [expanded, setExpanded] = useState(null);

  const q = query.trim().toLowerCase();

  const filtered = useMemo(() => {
    if (!q) return SCHEME_I_DATA;
    return SCHEME_I_DATA
      .map((cat) => {
        const categoryMatches = cat.category.toLowerCase().includes(q);
        const matchingProducts = cat.products.filter(
          (p) => p.product.toLowerCase().includes(q) || p.isNo.toLowerCase().includes(q)
        );
        if (categoryMatches) return cat;
        if (matchingProducts.length) return { ...cat, products: matchingProducts };
        return null;
      })
      .filter(Boolean);
  }, [q]);

  const handleChange = (panel) => (e, isExpanded) => setExpanded(isExpanded ? panel : null);

  return (
    <Box sx={{ backgroundColor: '#F8FAFC', minHeight: '100vh' }}>
      <SEO
        title="Products Under Compulsory BIS Certification (Scheme I — ISI Mark) | VforU Global"
        description="Browse all products covered under BIS Scheme I (ISI Mark) compulsory certification — cement, electrical goods, batteries, medical equipment, steel products and more, with the applicable Indian Standard for each."
        path="/services/certification/products-under-compulsory-certification"
        structuredData={[
          organizationSchema(),
          breadcrumbSchema([
            { name: 'Home', path: '/' },
            { name: 'Services', path: null },
            { name: 'Certification Consultancy', path: '/services/certification' },
            { name: 'Products Under Compulsory Certification', path: '/services/certification/products-under-compulsory-certification' },
          ]),
        ]}
      />

      {/* Header */}
      <Box sx={{ background: 'linear-gradient(135deg, #050F24 0%, #1D4ED8 100%)', py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <Breadcrumbs
            separator={<NavigateNextIcon sx={{ fontSize: 16, color: '#64748B' }} />}
            sx={{ mb: 3, '& a': { color: '#93C5FD', textDecoration: 'none', fontSize: 13 }, '& p': { color: '#94A3B8', fontSize: 13 } }}
          >
            <Typography component={Link} to="/">Home</Typography>
            <Typography component={Link} to="/services/certification">Certification Consultancy</Typography>
            <Typography sx={{ color: '#fff !important' }}>Products Under Compulsory Certification</Typography>
          </Breadcrumbs>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
            <Box sx={{ width: 48, height: 48, borderRadius: 2, background: 'rgba(37,99,235,0.3)', border: '1px solid rgba(37,99,235,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <GavelIcon sx={{ fontSize: 26, color: '#93C5FD' }} />
            </Box>
            <Chip label="BIS Scheme I — ISI Mark" sx={{ backgroundColor: 'rgba(37,99,235,0.2)', color: '#93C5FD', border: '1px solid rgba(37,99,235,0.3)', fontWeight: 500 }} />
          </Box>
          <Typography variant="h1" sx={{ fontWeight: 800, color: '#fff', fontSize: { xs: 28, md: 44 }, letterSpacing: '-0.5px', mb: 2 }}>
            Products Under Compulsory Certification
          </Typography>
          <Typography sx={{ color: '#94A3B8', fontSize: 16, lineHeight: 1.8, maxWidth: 640, mb: 4 }}>
            Search or browse every product category covered under BIS Scheme I (ISI Mark). Not sure which standard applies to your product? Talk to our certification team.
          </Typography>

          {/* Search */}
          <TextField
            fullWidth
            placeholder="Search by product name, IS number, or category…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: '#94A3B8' }} />
                </InputAdornment>
              ),
            }}
            sx={{
              maxWidth: 560,
              backgroundColor: '#fff',
              borderRadius: 2,
              '& .MuiOutlinedInput-root': { borderRadius: 2, fontSize: 15 },
            }}
          />
          <Typography sx={{ color: '#64748B', fontSize: 13, mt: 1.5 }}>
            {TOTAL_PRODUCTS}+ products across {SCHEME_I_DATA.length} categories currently listed — more being added.
          </Typography>
        </Container>
      </Box>

      {/* Results */}
      <Container maxWidth="lg" sx={{ py: 7 }}>
        {filtered.length === 0 && (
          <Box sx={{ textAlign: 'center', py: 10 }}>
            <Typography sx={{ fontSize: 17, fontWeight: 700, color: '#0F172A', mb: 1 }}>No matches found</Typography>
            <Typography sx={{ fontSize: 14, color: '#64748B', mb: 3 }}>
              Try a different product name, IS number, or category — or ask our team directly.
            </Typography>
            <Button component={Link} to="/contact" variant="contained" endIcon={<ArrowForwardIcon />}
              sx={{ backgroundColor: '#0A1628', textTransform: 'none', fontWeight: 600, borderRadius: 1.5, boxShadow: 'none', '&:hover': { backgroundColor: '#1E3A5F' } }}>
              Ask Our Certification Team
            </Button>
          </Box>
        )}

        {filtered.map((group) => (
          <Accordion
            key={group.category}
            expanded={q ? true : expanded === group.category}
            onChange={handleChange(group.category)}
            elevation={0}
            sx={{
              border: '1px solid #E2E8F0', borderRadius: 3, mb: 2,
              '&:before': { display: 'none' }, overflow: 'hidden',
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ fontSize: 28 }} />} sx={{ backgroundColor: '#fff', py: 1.5, px: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, width: '100%', flexWrap: 'wrap' }}>
                <Box sx={{
                  width: 84, height: 84, borderRadius: 2.5, flexShrink: 0, overflow: 'hidden',
                  background: group.deNotified ? '#F1F5F9' : 'linear-gradient(135deg, #EFF6FF, #DBEAFE)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  border: '1px solid #E2E8F0',
                }}>
                  {group.image ? (
                    <Box component="img" src={group.image} alt={group.category} loading="lazy"
                      sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                  ) : (
                    <Inventory2Icon sx={{ fontSize: 34, color: group.deNotified ? '#94A3B8' : '#2563EB' }} />
                  )}
                </Box>
                <Box sx={{ flex: 1, minWidth: 200 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                    <Typography sx={{ fontWeight: 800, fontSize: 18, color: '#0F172A' }}>{group.category}</Typography>
                    <Chip
                      label={`${group.products.length} item${group.products.length !== 1 ? 's' : ''}`}
                      size="small"
                      sx={{ backgroundColor: '#F8FAFC', border: '1px solid #E2E8F0', fontSize: 11, color: '#64748B' }}
                    />
                    {group.deNotified && (
                      <Chip label="De-notified" size="small" sx={{ backgroundColor: '#FFFBEB', color: '#B45309', fontSize: 11, fontWeight: 700 }} />
                    )}
                    {group.partial && (
                      <Chip label="More being added" size="small" sx={{ backgroundColor: '#ECFDF5', color: '#059669', fontSize: 11, fontWeight: 700 }} />
                    )}
                  </Box>
                  {group.description && (
                    <Typography sx={{ fontSize: 13, color: '#64748B', mt: 0.3 }}>{group.description}</Typography>
                  )}
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              {group.notification && (
                <Box sx={{ px: 3, py: 1.5, backgroundColor: '#F8FAFC', borderTop: '1px solid #E2E8F0', borderBottom: '1px solid #E2E8F0' }}>
                  <Typography sx={{ fontSize: 12, color: '#94A3B8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.3 }}>
                    Notified Under
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: '#475569', lineHeight: 1.6 }}>{group.notification}</Typography>
                </Box>
              )}
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#FAFAFA' }}>
                      <TableCell sx={{ fontWeight: 700, fontSize: 12, color: '#475569', width: 70 }}>Sr No.</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: 12, color: '#475569', width: 170 }}>IS No.</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: 12, color: '#475569' }}>Product</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {group.products.map((p, i) => (
                      <TableRow key={`${p.isNo}-${i}`} sx={{ '&:hover': { backgroundColor: '#F8FAFC' } }}>
                        <TableCell sx={{ fontSize: 13, color: '#64748B' }}>{p.srNo ?? '—'}</TableCell>
                        <TableCell>
                          <Chip label={p.isNo} size="small" sx={{ backgroundColor: '#EFF6FF', color: '#2563EB', fontWeight: 700, fontSize: 11 }} />
                        </TableCell>
                        <TableCell sx={{ fontSize: 13.5, color: '#0F172A' }}>
                          {p.product}
                          {group.deNotified && (
                            <Typography component="span" sx={{ fontSize: 11.5, color: '#B45309', fontWeight: 600, ml: 1 }}>
                              (De-notified)
                            </Typography>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        ))}

        {/* CTA */} 
        <Box sx={{ mt: 6, background: 'linear-gradient(135deg, #050F24, #1D4ED8)', borderRadius: 4, p: 6, textAlign: 'center', boxShadow: '0 24px 60px rgba(5,15,36,0.2)' }}>
          <Typography variant="h4" sx={{ fontWeight: 800, color: '#fff', mb: 1.5, letterSpacing: '-0.5px' }}>
            Not sure which standard applies to your product?
          </Typography>
          <Typography sx={{ color: '#93C5FD', mb: 4, fontSize: 16 }}>Talk to our certification team — free consultation, no obligation.</Typography>
          <Button component={Link} to="/contact" variant="contained" endIcon={<ArrowForwardIcon />}
            sx={{ background: 'linear-gradient(135deg, #fff, #EFF6FF)', color: '#1D4ED8', textTransform: 'none', fontWeight: 700, fontSize: 15, px: 5, py: 1.5, borderRadius: 2, '&:hover': { transform: 'translateY(-2px)' }, transition: 'all 0.25s ease' }}>
            Ask Our Certification Team
          </Button>
        </Box>
      </Container>
    </Box>
  );
}